import script from "./Invoice.vue?vue&type=script&setup=true&lang=js"
export * from "./Invoice.vue?vue&type=script&setup=true&lang=js"

import "./Invoice.vue?vue&type=style&index=0&id=1c416d38&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c416d38"]])

export default __exports__